<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <template v-if="true">
      <div class="text__view flex flex-col justify-center text-center mb-10">
        <h1 class="font-semibold text-2xl my-5">My Favorites</h1>
        <p class="leading-6 max-w-5xl mx-auto"></p>
      </div>
      <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-3">
        <Select
          placeholder="Search"
          class="xl:col-start-2 xl:col-end-3 mr-0 pr-0 mt-3"
          :options="search_by_catagory"
          v-model="search"
        />
      </div>
      <div
        class="library__list py-4 lg:py-10 items-start"
        v-if="favoriteGeneral && favoriteGeneral.length"
      >
        <component
          v-for="ad in favoriteGeneral"
          :key="ad.id"
          :data="ad"
          class="library__item"
          :isCollection="false"
          :is="ad.type_ad"
        >
        </component>
      </div>
      <div
        class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
        v-else
      >
        <div>
          <h2 class="text-4xl font-semibold mb-4">
            Your favorite list is empty 💔
          </h2>
          <p class="mb-10 text-lg">
            <!-- We recommend you check the completed library and select the awesome
            ads for you -->
            Please go back our full library and select the ones you love
          </p>
          <router-link to="/" class="flex justify-center">
            <Button class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
              >Go To Ads Library</Button
            >
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { computed, ref, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import Ad from "@/components/Ad/index";
import Brand from "@/components/Brand/index";
import TiktokVideo from "@/components/TiktokVideo/index";
import Button from "@/components/UI/Button";
import Plans from "@/components/Plans";
import Select from "@/components/UI/Select/index";

export default {
  components: {
    HeaderApp,
    Ad,
    Brand,
    TiktokVideo,
    AdblockTopbar,
    Button,
    Plans,
    Select,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    let FbandIG = ref(false);
    let Tiktoks = ref(false);
    let Brands = ref(false);
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      }
    });
    const filters = computed(() => {
      if (FbandIG.value) {
        return {
          industry: true,
          objective: true,
          type: true,
          format: true,
        };
      } else if (Brands.value) {
        return {
          industry: true,
          country: true,
        };
      } else if (Tiktoks.value) {
        return {
          industry: true,
        };
      } else {
        return {};
      }
    });
    const search_by_catagory = computed(() => [
      { label: "All", value: "All" },
      { label: fb_ig_title_subtitle.value.title, value: "FB_IG_Ads" },
      { label: tiktok_title_subtitle.value.title, value: "TikTok" },
      { label: top_brand_title_subtitle.value.title, value: "Brands" },
    ]);
    const search = ref("All");

    watch(search, (newsearch) => {
      if (newsearch === "All") {
        FbandIG.value = false;
        Brands.value = false;
        Tiktoks.value = false;
      } else if (newsearch === "FB_IG_Ads") {
        FbandIG.value = true;
        Brands.value = false;
        Tiktoks.value = false;
      } else if (newsearch === "TikTok") {
        FbandIG.value = false;
        Brands.value = false;
        Tiktoks.value = true;
      } else if (newsearch === "Brands") {
        Brands.value = true;
        Tiktoks.value = false;
        FbandIG.value = false;
      }
    });
    const fb_ig_title_subtitle = computed(() => store.state.fbIgTitleSubtitle);
    const tiktok_title_subtitle = computed(
      () => store.state.tiktokTitleSubtitle
    );
    const top_brand_title_subtitle = computed(
      () => store.state.topBrandTitleSubtitle
    );

    const favoritesTopBrands = computed(() =>
      store.state.favoritesTopBrands && store.state.favoritesTopBrands.length
        ? store.state.favoritesTopBrands.map((element) => {
            return { ...element, type_ad: "Brand" };
          })
        : []
    );
    const favoritesTiktoks = computed(() =>
      store.state.favoritesTiktoks && store.state.favoritesTiktoks.length
        ? store.state.favoritesTiktoks.map((element) => {
            return { ...element, type_ad: "TiktokVideo" };
          })
        : []
    );
    const favoritesFbandIG = computed(() =>
      store.state.favoritesAds && store.state.favoritesAds.length
        ? store.state.favoritesAds.map((element) => {
            return { ...element, type_ad: "Ad" };
          })
        : []
    );
    const roleUser = computed(() => store.state.role);
    const favoriteGeneral = computed(() => {
      if (FbandIG.value) {
        return favoritesFbandIG.value;
      } else if (Brands.value) {
        return favoritesTopBrands.value;
      } else if (Tiktoks.value) {
        return favoritesTiktoks.value;
      } else {
        return [
          ...favoritesFbandIG.value,
          ...favoritesTopBrands.value,
          ...favoritesTiktoks.value,
        ];
      }
    });
    return {
      favoriteGeneral,
      favoritesTiktoks,
      roleUser,
      FbandIG,
      Tiktoks,
      Brands,
      filters,
      search_by_catagory,
      search,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
